export enum FieldReportDeliveryExcel {
    LadingCode = 'ladingCode',
    Receiver = 'receiver',
    Hour = 'hour',
    Minute = 'minute',
    Day = 'day',
    Month = 'month',
    Year = 'year',
    Note = 'note'
}